<template>
  <div class="sign">
    <el-dialog
      title="在线签名"
      :visible.sync="visible"
      :before-close="handleBefore"
      v-dialogDrag
      :show-close="false"
      :append-to-body="true"
    >
      <!-- <el-dialog title="在线签名" :visible.sync="visible" :before-close="handleBefore"> -->
      <sign-canvas class="sign-canvas" ref="SignCanvas" :options="options" v-model="value" />
      <div class="btnList">
        <el-button type="warning" size="small" icon="el-icon-close" @click="closeClick">关闭</el-button>
        <el-button type="danger" size="small" icon="el-icon-delete" @click="canvasClear()">清空</el-button>
        <el-button type="primary" size="small" icon="el-icon-check" @click="saveAsImg()">保存</el-button>
        <!--        <el-button-->
        <!--          type="info"-->
        <!--          size="small"-->
        <!--          icon="el-icon-download"-->
        <!--          circle-->
        <!--          @click="downloadSignImg()"-->
        <!--          >下载</el-button-->
        <!--        >-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
export default {
  name: 'signDialog',
  props: {
    //弹窗变量
    visible: {
      type: Boolean,
      default: false,
    },
    //图片信息Base64
    src: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      // 七牛上传相关
      postData: {
        token: '',
        key: '',
      },
      value: null,
      options: {
        visibleDetails: false,
        writeUrl: '',
        token: '',
        member_id: '',
        company_id: '',
        lastWriteSpeed: 1, //书写速度 [Number] 可选
        lastWriteWidth: 2, //下笔的宽度 [Number] 可选
        lineCap: 'round', //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]    正方形线帽
        lineJoin: 'round', //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
        canvasWidth: 800, //canvas宽高 [Number] 可选
        canvasHeight: 500, //高度  [Number] 可选
        isShowBorder: false, //是否显示边框 [可选]
        bgColor: 'rgba(255,255,255,0)', //背景色 [String] 可选
        borderWidth: 1, // 网格线宽度  [Number] 可选
        borderColor: '#ff787f', //网格颜色  [String] 可选
        writeWidth: 5, //基础轨迹宽度  [Number] 可选
        maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
        minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
        writeColor: '#101010', // 轨迹颜色  [String] 可选
        isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        imgType: 'png', //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
      },
    }
  },
  components: {
    Draggable,
  },
  methods: {
    // 获取七牛云token
    async getQiniuToken() {
      console.log('审批qiNiu token触发了')
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      const res = await this.$axios({
        method: 'post',
        url: '/api/Qiniu/qiniuToken',
        data: param,
      })
      this.postData.token = res.data
      // console.log('this.postData', res.data)
    },
    handleBeforede() {
      this.visibleDetails = false
    },
    /**
     * 清除画板
     */
    canvasClear() {
      this.$refs.SignCanvas.canvasClear()
      this.$emit('wirtDoen', '')
    },

    /**
     * 保存图片
     */
    async saveAsImg() {
      const img = this.$refs.SignCanvas.saveAsImg()
      // alert(`image 的base64：${img}`)
      // console.log('-', img)
      // 上传图片
      // var file = this.base64toFile(img, '签名')
      // let param = new FormData()
      // param.append('member_id', this.member_id)
      // param.append('file', file)
      // const { data: res } = await this.$axios({
      //   method: 'post',
      //   headers: { 'content-type': 'application/x-www-form-urlencoded' },
      //   url: '/api/User/uploadImg',
      //   data: param,
      // })
      // if (res.code != 200) return this.$message.error(res.datas.msg)
      // this.$message.success('签名成功')
      // this.writeUrl = res.datas.img_url

      var file = this.base64toFile(img, '签名')
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('file', file)
      param.append('token', this.postData.token)
      // param.append('postData', postData)

      const { data: res } = await this.$https({
        method: 'post',
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
        url: 'https://upload-z2.qiniup.com',
        data: param,
      })
      if (!res.key) return this.$message.error('签字失败')
      this.$message.success('签名成功')
      // this.writeUrl = res.datas.img_url
      this.writeUrl = 'http://qiniu.sxpz.vip/' + res.key

      console.log('签名', this.writeUrl)
      this.$emit('wirtDoen', this.writeUrl)
      this.$emit('update:visible', false)
    },
    closeClick() {
      this.$emit('update:visible', false)
    },
    base64toFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    /**
     * 下载图片
     */
    downloadSignImg() {
      this.$refs.SignCanvas.downloadSignImg()
    },
    handleBefore() {
      return this.$emit('update:visible', false)
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.getQiniuToken()
  },
}
</script>

<style lang="less" scoped>
.sign {
  /deep/.el-dialog {
    // background: #b4a078;
    min-width: 840px;
  }
  /deep/.el-dialog__header {
    padding: 2px 0px;
  }
  /deep/.el-dialog__body {
    padding: 20px 0;
    box-sizing: border-box;
    // height: 50vh;
  }
  /deep/.el-button {
    /* font-family STXingkai */
    font-size: 12px;
    font-weight: 400;
  }

  .btnList {
    // padding: 5px;
    margin-left: 20px;
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: space-around;
  }

  /deep/.el-dialog__title {
    // line-height: 32px;
    // font-size: 24px;
    /* font-family STXingkai */
    // color: hsl(40, 28.57%, 30.82%);
    // text-shadow: 0 0.03em 0.03em black;
  }

  .sign-canvas {
    display: block;
    margin: 0 auto;
    background: #f4f0ea;
    border-radius: 8px;
  }
}
/deep/.el-dialog__wrapper {
  z-index: 9999 !important;
}
</style>